import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import "./AllowanceModal.css";
import { Grid } from "@mui/material";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import { useSelector } from "react-redux";
import Stack from "@mui/material/Stack";
import { v4 as uuidv4 } from "uuid";
import { getAllowanceUserOnSearch } from "../common/constants/globalconstants";
import { IconButton } from "@mui/material";
import AllowanceListingSearch from "../listings/AllowanceListingSearch";
import SSNTextField from "../common/SSNTextField";
import ErrorModal from "../common/ErrorModal";
import axiosInstance from "../common/AxiosInterceptor";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  padding: "20px !important",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  maxHeight: "80%",
  overflowY: "auto",
  borderRadius:"10px"
};

export default function SearchAllowanceModal(props) {
  const {getData,
  open,
  plzclose} = props;
  const [resetFlag, setResetFlag] = React.useState(false);
  const [records, setRecords] = useState([]);
  const [showSSN, setShowSSN] = useState(false);
  const [hasFocus, setFocus] = useState(false);
  const [loading, setloading] = useState(false);
  const [resetPagination, setRstPagination] =useState(false);
  const [errormodalopen, seterrormodalOpen]= useState(false);
  const storetoken = useSelector((state) => state.storetoken);
  const storeuser = useSelector((state) => state.storeuser);
  const [allowancefields, setAllowanceFields] = useState({
    firstName: "",
    lastName: "",
    ssn: "",
  });

  const handleChangeInput = (e) => {
    e.preventDefault();
    const regex = /^[0-9]*$/;
    if (e.target.name === "ssn") {
      const value = e.target.value;
      if (regex.test(value)) {
        setAllowanceFields({ ...allowancefields, ssn: value });
      }
    } else {
      setAllowanceFields({
        ...allowancefields,
        [e.target.name]: e.target.value,
      });
    }
  };

  useEffect(() => {
    getUserAllowanceRecords("initial");
  }, [storeuser.email]);

  const getUserAllowanceRecords = async (type) => {
    try {
      setloading(true);
      let request;
      if(type == "initial"){
       request = {
        userName: storeuser.email ? storeuser.email : "",
        payeeFirstName: allowancefields.firstName
          ? allowancefields.firstName
          : "",
        payeeLastName: allowancefields.lastName ? allowancefields.lastName : "",
        ssn: allowancefields.ssn ? allowancefields.ssn : "",
      };
    }else{
      request = {
        userName: storeuser.email ? storeuser.email : "",
        payeeFirstName: "",
        payeeLastName: "",
        ssn: "",
      }
    }
    const response = await axiosInstance.post(`${getAllowanceUserOnSearch}`, JSON.stringify(request));
      if (response.data.isSuccess) {
        const dataWithIds = response.data.result.map((record) => ({
          ...record,
          rowKey: uuidv4(),
        }));
        setRecords(dataWithIds);
        seterrormodalOpen(false);
      } else if (!response.data.isSuccess) {
        seterrormodalOpen(true);
      }
      setloading(false);
    } catch (error) {
      console.log(error);
      seterrormodalOpen(true);
      setloading(false);
    }
  };

  //Invoked on search click
  const searchAllowanceUser = async () => {
    try {
      setloading(true);
      setRstPagination(!resetPagination);
      const request = {
        userName: storeuser.email ? storeuser.email : "",
        payeeFirstName: allowancefields.firstName
          ? allowancefields.firstName
          : "",
        payeeLastName: allowancefields.lastName ? allowancefields.lastName : "",
        ssn: allowancefields.ssn ? allowancefields.ssn : "",
      };

      const response = await axiosInstance.post(`${getAllowanceUserOnSearch}`,
          JSON.stringify(request));         

      if (response.data.isSuccess) {
        const dataWithIds = response.data.result.map((record) => ({
          ...record,
          rowKey: uuidv4(),
        }));
        setRecords(dataWithIds);
        //props.requestsnackbardata(true);
        seterrormodalOpen(false);
        //plzclose();
      } 
      else if (!response.data.isSuccess) {
        seterrormodalOpen(true);
      }
      setloading(false);
    } catch (error) {
      console.log(error);
      seterrormodalOpen(true);
      setloading(false);
    }
  };


  const handleReset = () => {
    setRstPagination(!resetPagination);
    setResetFlag(true);
    getUserAllowanceRecords("reset");
    setAllowanceFields({ ...allowancefields, 
      firstName:"",
      lastName: "",
      ssn:"" });
  };

  const handleOnBlur = (e) => {
    if (!e.target.value.trim()) {
      setFocus(false);
    }
  };

  const handleClickShowSSN = () => {
    setShowSSN(!showSSN);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={plzclose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modalstyle"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h5" component="h2">
            User Search
            <IconButton
              aria-label="close"
              onClick={plzclose}
              sx={{
                position: "absolute",
                right: 35,
                top: 20,
                color: "white",
                backgroundColor: "red",
                padding: "2px",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Typography>
          <hr></hr>
          <br></br>
          <Grid
            item
            xs={7.7}
            sx={{
              p: "5px 16px",
              border: "1.5px solid #dfe3e8",
              borderRadius: "5px",
              backgroundColor: "white",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: "65px", m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">First Name</p>
                <TextField
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="First Name"
                  name="firstName"
                  value={allowancefields.firstName}
                  sx={{ width: "190px"}}
                  onChange={handleChangeInput}
                  inputProps={{ className: "search-text" }}
                ></TextField>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label">Last Name</p>
                <TextField
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="Last Name"
                  onChange={handleChangeInput}
                  value={allowancefields.lastName}
                  inputProps={{ className: "search-text" }}
                  name="lastName"
                  sx={{ width: "190px"}}
                ></TextField>
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: "65px", m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                
                <p className="input-label">SSN</p>
                <SSNTextField name="ssn" onChange={handleChangeInput} value={allowancefields.ssn}
                  showSSN={showSSN} setFocus={setFocus} handleOnBlur={handleOnBlur} handleClickShowSSN={handleClickShowSSN}
                  editable="Yes"  />
              </Box>

              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  paddingLeft: "25px",
                }}
              >
                <Button
                  variant="contained"
                  id="btn10"
                  onClick={searchAllowanceUser}
                >
                  Search
                </Button>
              </Box>

              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <Button
                  variant="outlined"
                  sx={{
                    width: "120px !important",
                    height: "40px",
                    marginLeft: "10px",
                    textTransform: "unset !important",
                  }}
                  onClick={handleReset}
                >
                  Reset
                </Button>
              </Box>
            </Stack>
          </Grid>

          <br></br>
          <AllowanceListingSearch
            getData={getData}
            plzclose={plzclose}
            records={records}
            loading={loading}
            resetPagination={resetPagination}
          />          
        </Box>
      </Modal>
      {errormodalopen && (
        <ErrorModal open={true} onClose={() => seterrormodalOpen(false)} />
      )}
    </div>
  );
}
